import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=4601bc30&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=4601bc30&prod&scoped=true&lang=scss"
import style1 from "./Events.vue?vue&type=style&index=1&id=4601bc30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601bc30",
  null
  
)

export default component.exports